import { Box } from "@mantine/core";
import { isArray } from "lodash-es";
import { ReactNode } from "react";

import { useMuiResponsiveValue } from "~/hooks/useMuiResponsiveValue";

const TileGrid = ({
  children,
  maxCols,
}: {
  children: ReactNode;
  maxCols?: number;
}) => {
  const childrenLength =
    isArray(children) && children.length ? children.length : 1;
  const lgCols = maxCols ?? childrenLength ?? 4;
  // An explicit maxCols caps every breakpoint — otherwise a 3-tile grid would
  // still render 4 md columns and leave a dead column on the right.
  const cols = useMuiResponsiveValue({
    xs: 1,
    sm: 2,
    md: maxCols != null ? Math.min(maxCols, 4) : 4,
    lg: lgCols,
  });

  return (
    <Box
      style={{
        display: "grid",
        gridGap: "1rem",
        gridAutoColumns: "minmax(0, 1fr)",
        gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))`,
      }}
    >
      {children}
    </Box>
  );
};

export default TileGrid;
